export default __webpack_public_path__ + "images/models/3c7e3ca169fcaeeb172bbb39469186a1.usdz";